export const areChangesSavedGlobally = (state) =>
  state.saveChangesDetails.areChangesSaved;

export const saveChangesClickHandlerForCurrentPageFn = (state) =>
  state.saveChangesDetails.currentSaveActionCreatorFn;
